"use strict";

module.exports = function (bucketName) {
  return bucketName + ".s3.amazonaws.com";
};